import type { DefaultWeek } from './api';

const WEEKDAYS = [1, 2, 3, 4, 5];

/** Every lesson cell of every day has a subject: the week is done. */
export function weekIsComplete(week: Pick<DefaultWeek, 'periods' | 'lessons'>): boolean {
  const lessonPeriods = week.periods.filter((period) => !period.isBreak);
  if (lessonPeriods.length === 0) return false;
  return lessonPeriods.every((period) =>
    WEEKDAYS.every((weekday) =>
      week.lessons.some((lesson) => lesson.periodId === period.id && lesson.weekday === weekday && lesson.subjectId !== null),
    ),
  );
}

/** No cell has a subject yet. */
export function weekIsEmpty(week: Pick<DefaultWeek, 'periods' | 'lessons'>): boolean {
  return !week.lessons.some((lesson) => lesson.subjectId !== null);
}
